import GreenAudioPlayer from './js/GreenAudioPlayer';

import Turbolinks from 'turbolinks';
import hljs from 'highlight.js/lib/core';
import darklightswitch from './darklightswitch';

const configureHighlightJS = () => {

  const CopyButtonPlugin = require('./js/copy_button_plugin');

  hljs.registerLanguage('shell', require('highlight.js/lib/languages/shell'));
  hljs.registerLanguage('html', require('highlight.js/lib/languages/xml'));
  hljs.registerLanguage('php', require('highlight.js/lib/languages/php'));
  hljs.registerLanguage('javascript', require('highlight.js/lib/languages/javascript'));
  hljs.registerLanguage('yaml', require('highlight.js/lib/languages/yaml'));
  hljs.registerLanguage('bash', require('highlight.js/lib/languages/bash'));
  hljs.registerLanguage('coffee', require('highlight.js/lib/languages/coffeescript'));
  hljs.registerLanguage('erb', require('highlight.js/lib/languages/erb'));
  hljs.addPlugin(new CopyButtonPlugin());

  require('highlightjs-copy/styles/highlightjs-copy.css');
  require('highlight.js/styles/github-dark.css');
}

configureHighlightJS();


Turbolinks.start()

const onDocumentReady = () => {

  darklightswitch(document.querySelector('.dark-light-switch'));

  if (typeof Prism !== 'undefined') {
    Prism.highlightAll();
  } else {
    console.debug('Warning: Prism is not loaded');
  }

  hljs.highlightAll();


  document.querySelectorAll('a[download][href$=".mp3"]').forEach((el) => {
    el.parentElement.innerHTML = `
    <div class="audioplayer">
      <audio>
          <source src="${el.getAttribute('href')}" type="audio/mpeg">
      </audio>
    </div>
    `
  });
  if (document.querySelector('.audioplayer')) {
    GreenAudioPlayer.init({
      selector: '.audioplayer',
      showDownloadButton: true
    });
  }


}


document.addEventListener("turbolinks:load", onDocumentReady);
